import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { Logo } from "./Logo";
import { useSite } from "../context/SiteContext";

export const Footer = () => {
  const { settings } = useSite();
  const email = settings?.contact?.email;
  const socials = [
    ["Instagram", settings?.socials?.instagram, Instagram],
    ["Facebook", settings?.socials?.facebook, Facebook],
    ["YouTube", settings?.socials?.youtube, Youtube],
  ];
  return (
    <footer data-testid="site-footer" className="bg-wine text-ivory">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 pt-20 pb-10">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-8 max-w-xs font-serif text-2xl italic leading-snug text-ivory/90">
              “Visual stories, created with intention.”
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow text-champagne">Quick Links</p>
            <ul className="mt-6 space-y-3 text-sm">
              {["Portfolio", "Services", "About", "Contact"].map((l) => (
                <li key={l}>
                  <Link to={`/${l.toLowerCase()}`} className="footer-link" data-testid={`footer-link-${l.toLowerCase()}`}>
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow text-champagne">Social</p>
            <ul className="mt-6 flex gap-3">
              {socials.map(([label, href, Icon]) => (
                <li key={label}>
                  {href ? (
                    <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} title={label} className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/40 text-ivory transition-colors duration-300 hover:border-ivory hover:bg-ivory hover:text-wine" data-testid={`footer-social-${label.toLowerCase()}`}>
                      <Icon size={18} strokeWidth={1.4} />
                    </a>
                  ) : (
                    <span aria-label={`${label} (coming soon)`} title={`${label} — coming soon`} className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/25 text-ivory/50" data-testid={`footer-social-${label.toLowerCase()}`}>
                      <Icon size={18} strokeWidth={1.4} />
                    </span>
                  )}
                </li>
              ))}
            </ul>
            {email && (
              <a href={`mailto:${email}`} className="footer-link mt-6 inline-block text-sm" data-testid="footer-email">{email}</a>
            )}
          </div>
        </div>
        <div className="mt-20 flex flex-col gap-4 border-t border-ivory/20 pt-8 text-xs text-ivory/75 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} BWI — Built With Intention.</p>
          <Link to="/privacy" className="footer-link" data-testid="footer-privacy-link">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};
